module.exports = __webpack_public_path__ + "static/media/kitsante.4b7e37ff.png";